import { UniformLogo, flattenLogoProps } from "src/uniform/contenttypes/logo";

import { Integration } from "@/libraries/design/patterns";
import {
    IntegrationBackgroundType,
    IntegrationBackgroundColor
} from "@/libraries/design/patterns/integration/src/integration";
import { RichTextComponent } from "@/libraries/design/utils";

export interface UniformIntegrationProps {
    eyebrow?: string;
    title?: string;
    titleAs?: "h2" | "h3";
    body?: string;
    richText?: string;
    linkLabel?: string;
    linkHref?: string;
    logos: UniformLogo[];
    background?: IntegrationBackgroundType;
    backgroundColor?: IntegrationBackgroundColor;
    flipLayout?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UniformIntegration = (props: any) => {
    const {
        eyebrow,
        title,
        titleAs,
        body,
        richText,
        linkLabel,
        linkHref,
        logos,
        background,
        backgroundColor,
        flipLayout
    } = flattenLogoProps(props);
    return (
        <Integration
            eyebrow={eyebrow}
            title={title}
            titleAs={titleAs}
            body={richText ? <RichTextComponent text={richText} /> : body}
            linkLabel={linkLabel}
            linkHref={linkHref}
            logos={logos}
            background={background}
            backgroundColor={backgroundColor}
            flipLayout={flipLayout}
        />
    );
};

export default UniformIntegration;
